// src/App.js
import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './assets/css/libraries.css';
import './assets/css/icons.css';
import './assets/css/style.css';
import './assets/css/richTextStyling.css';

import { usePreloader } from './hooks/usePreloader';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollTopButton from './components/ScrollTopButton';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Blogs from './pages/Blogs';
import Careers from './pages/Careers';
import FAQ from './pages/FAQ';
import Pricing from './pages/Pricing';
import BlogDetails from './pages/BlogDetails';
import Servicedetails from './components/ServicesSection';
import BookMeeting from './pages/BookMeeting';
import ScrollToTop from './common/ScrollToTop';
import AllServices from './components/AllServices';

// ============================================
// API CONFIGURATION FOR FRONTEND (Create React App)
// ============================================
const isDevelopment = process.env.NODE_ENV === 'development';

if (isDevelopment) {
  // DEVELOPMENT: Connect to local backend
  localStorage.setItem("api_url", "https://inscapeoutsourcing.com/user/data/api/");
  localStorage.setItem("base_url", "http://localhost/inscape_backend");
  localStorage.setItem("upload_url", "http://localhost/inscape_backend/upload/");
} else {
  // PRODUCTION: Connect to live backend
  localStorage.setItem("api_url", "https://inscapeoutsourcing.com/user/data/api/");
  localStorage.setItem("base_url", "https://inscapeoutsourcing.com/user/data");
  localStorage.setItem("upload_url", "https://inscapeoutsourcing.com/user/data/upload/");
}

console.log("Frontend Environment:", isDevelopment ? "Development" : "Production");
console.log("API URL:", localStorage.getItem("api_url"));
// ============================================

// ============================================
// FETCH COMPANY SETTINGS
// ============================================
const fetchCompanySettings = async () => {
  try {
    const apiUrl = localStorage.getItem("api_url");
    const companyId = "1"; // Replace with your actual company_id
    const employeeId = "1"; // Replace with your actual employee_id

    const formData = new FormData();
    formData.append('company_id', companyId);
    formData.append('employee_id', employeeId);
    formData.append('type', '2'); // Type 2 is for fetching settings

    const response = await fetch(`${apiUrl}company_settings.php`, {
      method: 'POST',
      body: formData
    });

    const data = await response.json();

    if (data.status === '1') {
      // Store the entire company settings object
      localStorage.setItem('company_settings', JSON.stringify(data.result));

      // Optionally store individual fields for easy access
      localStorage.setItem('company_name', data.result.company_name || '');
      localStorage.setItem('company_email', data.result.company_email_id || '');
      localStorage.setItem('company_mobile_1', data.result.company_mobile_no_1 || '');
      localStorage.setItem('company_mobile_2', data.result.company_mobile_no_2 || '');
      localStorage.setItem('company_address', data.result.company_address || '');
      localStorage.setItem('company_header_logo', data.result.company_header_logo_url || '');
      localStorage.setItem('company_footer_logo', data.result.company_footer_logo_url || '');
      localStorage.setItem('company_fav_logo', data.result.company_fav_logo_url || '');
      localStorage.setItem('company_fb_link', data.result.company_fb_link || '');
      localStorage.setItem('company_insta_link', data.result.company_insta_link || '');
      localStorage.setItem('company_youtube_link', data.result.company_youtube_link || '');
      localStorage.setItem('company_linkedIn_link', data.result.company_linkedIn_link || '');
      localStorage.setItem('company_twitter_link', data.result.company_twitter_link || '');
      localStorage.setItem('company_location_URL', data.result.company_location_URL || '');

      localStorage.setItem('number_client', data.result.number_client || '');
      localStorage.setItem('number_hours', data.result.number_hours || '');
      localStorage.setItem('number_no_of_exp', data.result.number_no_of_exp || '');
      localStorage.setItem('number_team_member', data.result.number_team_member || '');

      console.log('Company settings loaded successfully:', data.result);
    } else {
      console.error('Failed to fetch company settings:', data.error);
    }
  } catch (error) {
    console.error('Error fetching company settings:', error);
  }
};

function App() {
  usePreloader();

  // Fetch company settings on app load
  useEffect(() => {
    fetchCompanySettings();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="wrapper">
        {/* Preloader */}
        <div className="preloader">
          <div className="loading">
            <span></span><span></span><span></span><span></span>
          </div>
        </div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blogDetails/:id?" element={<BlogDetails />} />
          <Route path="/serviceDetails/:id?" element={<Servicedetails />} />
          <Route path="/bookMeeting" element={<BookMeeting />} />
          <Route path="/services" element={<AllServices />} />

          {/* Add more routes */}
        </Routes>

        <Footer />
        <ScrollTopButton />
      </div>
    </Router>
  );
}

export default App;